import {
  STREAM_NOTIFICATIONS_REQUEST,
  STREAM_NOTIFICATIONS_SUCCESS,
  STREAM_NOTIFICATIONS_FAILURE
} from 'src/actions/actionTypes'

const initialState = {}

const initialHomeState = tokenValue => ({
  tokenValue,
  notifications: [],
  error: null
})

const initializeHomeState = (state, { homeRef, tokenValue }) => ({
  [homeRef]: initialHomeState(tokenValue),
  ...state
})

const success = (state, { homeRef }, notifications) => ({
  ...state,
  [homeRef]: {
    ...state[homeRef],
    notifications,
    error: null
  }
})

const failure = (state, { homeRef }, error) => ({
  ...state,
  [homeRef]: {
    ...state[homeRef],
    error
  }
})

export default (
  state = initialState,
  { type, token, notifications, error }
) => {
  switch (type) {
    case STREAM_NOTIFICATIONS_REQUEST:
      return initializeHomeState(state, token)

    case STREAM_NOTIFICATIONS_SUCCESS:
      return success(state, token, notifications)

    case STREAM_NOTIFICATIONS_FAILURE:
      return failure(state, token, error)

    default:
      return state
  }
}
